/* eslint-disable */

const loadScript = async (src) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }
  const script = document.createElement('script');
  script.src = src;
  document.head.appendChild(script);
  await new Promise((resolve) => (script.onload = resolve));
};

export async function initOmiCallSDK(payload) {
  try {
    // 1. load script
    let version = '3.0.14';
    // get latest "version" in here: https://api.omicall.com/sdk/web-sdk/v3-changelog
    await loadScript(`https://cdn.omicrm.com/sdk/web/${version}/core.min.js`);

    validateCallSDK();

    // 2. init config for SDK
    const initSuccess = await OMICallSDK.init({
      lng: 'vi',
      ui: {
        toggleDial: 'show', // show | hide
        dialPosition: 'right', // left | right
      },
    });
    if (!initSuccess) {
      return;
    }

    const sipRealm = payload.domain; // domain tổng đài
    const sipUser = payload.username; // số nội bộ
    const sipPassword = payload.password; // mật khẩu của số nội bộ
    const registerStatus = await OMICallSDK.register({
      sipRealm,
      sipUser,
      sipPassword,
    });
    if (!registerStatus.status) {
      throw registerStatus;
    }
    registerEvent()
  } catch (error) {
    console.error(`initCallSDK -> error:`, error);
  }
}
function validateCallSDK() {
  if (typeof OMICallSDK == 'undefined') {
    throw new Error('OMICallSDK not loaded!');
  }
}

export function unRegisterCallSDK(e) {
  try {
    validateCallSDK();
    OMICallSDK.unregister();
  } catch (error) {
    console.error(`unRegisterCallSDK -> error:`, error);
  }
}

/** Register event OMICALL */
function registerEvent() {
  OMICallSDK.on('ended', (data) => {
    document.dispatchEvent(new CustomEvent('Omicall_ended', {
      detail: data
    }))
  });
}